var map = {
	"./bgm_game.mp3": "9998",
	"./bgm_out_game.mp3": "c40c",
	"./jingle_game_over.mp3": "e4a4",
	"./jingle_goal.mp3": "7c60",
	"./jingle_muteki.mp3": "abcc",
	"./jingle_result.mp3": "4088",
	"./jingle_title.mp3": "9e4f",
	"./se_add_score.mp3": "a941",
	"./se_click_button.mp3": "e5ce",
	"./se_click_cancel.mp3": "726d",
	"./se_move_page.mp3": "27a1",
	"./se_move_view.mp3": "1495c",
	"./se_player_cure_heart.mp3": "883f",
	"./se_player_damage.mp3": "dd6d",
	"./se_player_get_happyturn.mp3": "8890",
	"./se_player_get_item.mp3": "6f46",
	"./se_player_jump.mp3": "0d24",
	"./se_player_muteki.mp3": "4645",
	"./se_player_turn_jump.mp3": "3205",
	"./se_shot_handgun.mp3": "82bc",
	"./se_show_highscore.mp3": "7ad6",
	"./se_show_result_value.mp3": "1d6d",
	"./se_show_total_score.mp3": "570b",
	"./se_start_countdown.mp3": "6218"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "c3e4";